import { 
	ICopilotBlob,
	ICopilotResponse,
	ICopilotUserMessage,
	ICopilotUserSessionDetails,
	ICopilotUserSession
} from 'interfaces';
import { ICopilotClient } from './ICopilotClient';

export abstract class CopilotClient implements ICopilotClient {
	readonly endpoint: string;
	readonly sessionId: string;
	history: (ICopilotUserMessage | ICopilotResponse)[] = [];

	constructor(sessionId: string, endpoint: string) {
		this.sessionId = sessionId;
		this.endpoint = endpoint;
	}

	protected updateHistory(message: ICopilotUserMessage | ICopilotResponse): void {
		this.history.push(message);
	}

	abstract generateAnswer(blob: ICopilotBlob): Promise<ICopilotResponse>;
	abstract getUserId(): Promise<string | void>;
	abstract getUserSessions(): Promise<ICopilotUserSession[]>;
	abstract getUserSession(sessionId: string): Promise<ICopilotUserSessionDetails>;
}
